import React from "react";

import PropTypes from "prop-types";

import Chip from "@mui/material/Chip";
function ProjectStatusChip({
  // Props
  status,
}) {
  const color = React.useMemo(() => {
    switch (status) {
      case "Released":
        return "success";
      case "In Development":
        return "secondary";
      case "ICR Approved":
        return "secondary";
      case "On Hold":
        return "warning";
      case "Canceled":
        return "error";
      default:
        return "default";
    }
  }, [status]);

  return <Chip label={status} size="small" variant="outlined" color={color} />;
}

export default ProjectStatusChip;

ProjectStatusChip.propTypes = {
  status: PropTypes.string,
};
